import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import StoreAdminCreateItemsModal from "../components/storeAdminComponents/StoreAdminCreateItemsModal";
import { Link } from "react-router-dom";
import { getAllItems } from "../actions/itemActions";
import { useDispatch, useSelector } from "react-redux";
import StoreAdminItemsListRow from "../components/storeAdminComponents/StoreAdminItemsListRow";
import { paginationDataToShow } from "../actions/generalActions";

const StoreAdminItemsPage = () => {
  const items = useSelector((state) => state.items);
  const categories = useSelector((state) => state.categories);
  const subCategories = useSelector((state) => state.subCategories);

  const dispatch = useDispatch();
  const itemsData = async (e) => {
    dispatch(getAllItems());
  };
  useEffect(() => {
    itemsData();
  }, []);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortField, setSortField] = useState("name");
  const [sortOrder, setSortOrder] = useState("asc"); //asc, desc
  const [searchTerm, setSearchTerm] = useState("");
  const [limit, setLimit] = useState(25); // Set your default limit here

  // Function to handle pagination, sorting, and searching
  const handlePagination = (page, field, order, search, newLimit) => {
    let newPage;
    if (page < 1) {
      newPage = 1;
    } else if (page > paginatedData.totalPages) {
      newPage = paginatedData.totalPages;
    } else {
      newPage = page;
    }
    setCurrentPage(newPage);
    setSortField(field);
    setSortOrder(order);
    setSearchTerm(search);
    setLimit(newLimit);
  };

  const fullData = items?.items;
  // Use the pagination function to get the data for the current page
  const paginatedData = paginationDataToShow(
    limit,
    currentPage,
    fullData,
    sortField,
    sortOrder,
    searchTerm
  );
  // Function to handle sorting icon click
  const handleSortClick = (field, order) => {
    // Call handlePagination with sorting parameters
    handlePagination(currentPage, field, order, searchTerm, limit);
  };
  // Function to determine the color based on the current sorting order
  const getArrowColor = (field, direction) => {
    return sortField === field && sortOrder === direction
      ? "#000000"
      : "#A0A0A0";
  };
  return (
    <>
      <div className="main-wrapper">
        <Header />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row">
              <div className="col-xl-12 col-12">
                <div className="card rounded-1 card-table">
                  <div className="card-header py-3">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">Your Products</h5>
                      </div>
                      <div className="col-auto">
                        <div className="d-flex gap-3">
                          <Link to="/create-product">
                            <button
                              className="btn btn-primary"
                              data-bs-toggle="modal"
                              data-bs-target="#addnewModal"
                              //   onClick={openAddModal}
                            >
                              Add New
                            </button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="container">
                    <br />
                    <div className="products">
                      <div className="table-responsive">
                        <table className="table table-striped table-hover">
                          <thead className="thead-light">
                            <tr>
                              <th>Id</th>
                              <th>Cover</th>
                              <th>Product Name</th>
                              <th>Price</th>
                              <th>In Stock</th>
                              <th>Rating</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {items &&
                              items?.items &&
                              items?.items?.length > 0 &&
                              // store?.store?.map((current, i) => {
                              paginatedData?.results.map((current, i) => {
                                if (current.delete === false) {
                                  return (
                                    <StoreAdminItemsListRow
                                      current={current}
                                      i={i}
                                      key={i}
                                      // handleModal={handleModal}
                                    />
                                  );
                                }
                              })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <StoreAdminCreateItemsModal
        openAddModal={openAddModal}
        showAddModal={showAddModal}
      /> */}
    </>
  );
};

export default StoreAdminItemsPage;
